import * as React from 'react';
import { cn, formatLatency } from '../../lib/utils';

export interface LatencyChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Latency in milliseconds. */
  ms: number;
  /** Override thresholds (defaults: ≤500=good, ≤1500=warn, else=bad). */
  goodMs?: number;
  warnMs?: number;
}

function LatencyChip({
  ms,
  goodMs = 500,
  warnMs = 1500,
  className,
  ...props
}: LatencyChipProps): React.JSX.Element {
  const tier: 'good' | 'warn' | 'bad' = ms <= goodMs ? 'good' : ms <= warnMs ? 'warn' : 'bad';
  return (
    <span
      title={`Round-trip latency ${formatLatency(ms)}`}
      className={cn(
        'inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 font-mono text-[11px] tabular-nums',
        tier === 'good' && 'bg-success/15 text-success',
        tier === 'warn' && 'bg-warning/15 text-warning',
        tier === 'bad' && 'bg-destructive/15 text-destructive',
        className,
      )}
      {...props}
    >
      {formatLatency(ms)}
    </span>
  );
}

export { LatencyChip };
